<div class="modal-header">
    <div cvLocalizedText langSection="CXOne_Modal" langKey="Widget_Settings">Widget Settings</div>
    <input class="no-size ngbAutoFocus inputFocusSettings"> <!-- focus purposes -->
    <button type="button" (click)="cancel()" class="modal-close icon-btn fill-iconDefault">
        <svg class="icon-12"><use href="../App_Themes/CXone/icons/close.svg#close"></use></svg>
    </button>
</div>
<div class="modal-body cxone-module-settings-modal-body" *ngIf="moduleManager && settingsManager" [style.display]="!settingsLoading ? 'block' : 'none'">
    <div class="form-group pt-1">
        <label cvLocalizedText langSection="CXOne_Modal" langKey="Display_Name">Display Name</label>
        <input class="form-control" type="text" 
            [(ngModel)]="moduleManager.moduleOptions.editName" maxlength="35" [required]="true" #editName="ngModel" 
            [pattern]="invalidCharsRegex" (ngModelChange)="characterLimit(moduleManager.moduleOptions.editName)" 
            [ngStyle]="{ 'border-color': editName.errors?.['pattern'] ? '#F53946' : '' }"/>
            <div [hidden]="!editName.errors?.['required']"></div>
            <div class="character-limit" [hidden]="editName.errors?.['pattern'] || hidePlural">
                <span>{{getTextLimitMessage()}}</span>
            </div>
            <div class="character-limit" [hidden]="editName.errors?.['pattern'] || !hidePlural">
                <span>{{getTextLimitMessage()}}</span>
            </div>
        <div [hidden]="!editName.errors?.['pattern']" class="errorText" cvLocalizedText langSection="Dashboard_Input" langKey="PatternError"></div>
    </div>
    <hr class="mb-3" />
    <ng-container #beforeAll></ng-container>
    <div class="form-group position-relative" *ngIf="module.SettingMetricSelector">
        <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Metrics">Metrics</p>
        <button type="button"
                class="cxone-btn btn-medium btn-secondary mb-3"
                (click)="openMetricSelector()">
                <span *ngIf="module.MaxMetricCount === 1"  cvLocalizedText langSection="CXOne_Modal" langKey="Select_Metric">Select Metric</span>
                <span *ngIf="module.MaxMetricCount !== 1" cvLocalizedText langSection="CXOne_Modal" langKey="Select_Metrics">Select Metrics</span>
        </button>
        <cxone-selected-tags class="d-block"
                             style="margin-left: -6px"
                             [maxTagsToDisplay]="14"
                             [tagsSource]="settingsManager.selectedMetrics"
                             primaryKey="Id"
                             label="Abbreviation"
                             [removable]="true"
                             (tagDeleted)="removeMetric($event)"
                             [popUpContainer]="'.cxone-module-settings-modal-body'"></cxone-selected-tags>
        <ng-container #insideMetric></ng-container>
    </div>
    <div class="form-group" *ngIf="(module.SettingEmpSelector || module.SettingRecSelector || module.SettingAttSelector) && module.GroupSelectorShowToggle">
        <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="View">View</p>
        <label cvLocalizedText langSection="CXOne_Modal" langKey="View_By">View By</label>
        <cv-group-view-by-selector [stateKey]="stateKey + '_temp'" [settingsManager]="settingsManager" [removePocFilter]="module.SettingRemovePocFilter" [includeCustom]="customViewBy"></cv-group-view-by-selector>
        <ng-container #insideView></ng-container>
    </div>
    <ng-container #afterView></ng-container>
    <ng-container *ngIf="module.SettingDateRangeSelector && !hideSettingsDatePicker">
        <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Dates">Dates</p>
        <div class="form-group" *ngIf="isDateChangeAllowed()">
            <label *ngIf="moduleManager.maxDateRange > 1" cvLocalizedText langSection="CXOne_Modal" langKey="Date_Range">Date Range</label>
            <label *ngIf="moduleManager.maxDateRange === 1" cvLocalizedText langSection="CXOne_Modal" langKey="Date">Date</label>
            <cv-cxone-date-range-selector *ngIf="settingsManager.availableDateRanges !== null"
                [class.is-invalid]="!isDateRangeValid"
                [pageName]="stateKey + '_temp'"
                [settingsManager]="settingsManager"
                dropdownContainer=".cxone-module-settings-modal-body"
                [(selectedDateRange)]="settingsManager.selectedDateRange"
                [availableDateRanges]="settingsManager.availableDateRanges"
                (selectedDateRangeChange)="validateDateRange()"
                [maxDays]="moduleManager.maxDateRange"
            ></cv-cxone-date-range-selector>
            <div class="d-block invalid-feedback" *ngIf="!isDateRangeValid">{{ this.maxDateRangeText }}</div>
        </div>

        <div class="form-group" *ngIf="module.DateRangeSelectorHasDOW && isDayOfWeekAllowed()">
            <label cvLocalizedText langSection="CXOne_Modal" langKey="Days_Of_The_Week">Days of the Week</label>
            <cv-dow-selector
                [pageName]="stateKey + '_temp'"
                [settingsManager]="settingsManager"
                [(selectedDaysOfWeek)]="settingsManager.selectedDaysOfWeek"
                size="large"
            ></cv-dow-selector>
        </div>
        <div class="form-group" *ngIf="module.SettingTimeRangeSelector">
            <div class="d-flex">
                <label [class.w-50]="settingsManager.isTimeSelectorEnabled" cvLocalizedText langSection="CXOne_Modal" langKey="Time">Time</label>
                <label class="w-25 pl-3" *ngIf="settingsManager.isTimeSelectorEnabled" cvLocalizedText langSection="CXOne_Modal" langKey="From">From</label>
                <label class="w-25 pl-3" *ngIf="settingsManager.isTimeSelectorEnabled" cvLocalizedText langSection="CXOne_Modal" langKey="To">To</label>
            </div>
            <cv-time-range-selector
                [stateKey]="stateKey + '_temp'" 
                [settingsManager]="settingsManager"
                [hideDisabled]="true"
                displayMode="picker"
            ></cv-time-range-selector>
        </div>

        <div class="form-group" *ngIf="module.SettingIntervalSelector">
            <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Interval">Interval</p>
            <cv-interval-selector
                class="d-flex"
                [hideDisabled]="true"
                [settingsManager]="settingsManager"
                [stateKey]="stateKey + '_temp'"
                [showFifteenMinute]="settingsManager.fifteenMinutesIntervalVisible"
                [useGrid]="false"
                layout="reverse">
                <label interval-label cvLocalizedText langSection="CXOne_Modal" langKey="Interval_Unit">Interval Unit</label>
                <label amount-label cvLocalizedText langSection="CXOne_Modal" langKey="Every">Every</label>
            </cv-interval-selector>
        </div>
        <ng-container #insideDate></ng-container>
    </ng-container>
    <ng-container #afterDate></ng-container>
    <div class="form-group" *ngIf="module.SettingEmpSelector">
        <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Employee_Groups">Employee Groups</p>
        <cv-group-selector 
            [pageName]="stateKey + '_temp'" 
            [baseGroupType]="0"
            [showSelectedToggle]="false"
            [hasSelectedToggle]="settingsManager.selectedToggle === 0"
            (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
            [settingsManager]="settingsManager"
            [selectedGroupsDto]="settingsManager.empSelectorDTO"
            (selectedGroupsChanged)="settingsManager.onEmpGroupsChanged($event)"
            [hasMultiSelect]="module.GroupSelectorHasMulti"
            [removeTopLevel]="true"
            [newSettingsEmp]="module.SettingEmpLevels"
            direction="horizontal"
            [groupViewBy]="groupViewBy"
            [settingViewByLimitsFilters]="moduleManager.container.moduleInfo.DTO.SettingViewByLimitsFilters"
        ></cv-group-selector>
        <ng-container #insideEmp></ng-container>
    </div>
    <ng-container #afterEmp></ng-container>
    <div class="form-group pb-1" *ngIf="module.SettingRecSelector">
        <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Contact_Groups">Contact Groups</p>
        <cv-group-selector 
            [pageName]="stateKey + '_temp'" 
            [baseGroupType]="1"
            [showSelectedToggle]="false"
            [hasSelectedToggle]="settingsManager.selectedToggle === 1"
            (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
            [settingsManager]="settingsManager"
            [selectedGroupsDto]="settingsManager.recSelectorDTO"
            (selectedGroupsChanged)="settingsManager.onRecGroupsChanged($event)"
            [hasMultiSelect]="module.GroupSelectorHasMulti"
            [removeTopLevel]="true"
            [removePocFilter]="module.SettingRemovePocFilter"
            [newSettingsRec]="module.SettingRecLevels"
            [groupViewBy]="groupViewBy"
            [settingViewByLimitsFilters]="moduleManager.container.moduleInfo.DTO.SettingViewByLimitsFilters"
            direction="vertical"
        ></cv-group-selector>
        <ng-container #insideRec></ng-container>
    </div>
    <ng-container #afterRec></ng-container>
    <div class="form-group" *ngIf="module.SettingAttSelector">
        <div *ngIf="isSingleAttrSelector">
            <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Media">Media</p>
            <label cvLocalizedText langSection="CXOne_Modal" langKey="Media_Type">Media Type</label>
            <cv-single-attribute-selector 
                [settingsManager]="settingsManager" 
                class="d-flex" 
                attributeName="Media Type"
                [pageName]="stateKey + '_temp'">
            </cv-single-attribute-selector>
        </div>
        
        <div *ngIf="!isSingleAttrSelector">
            <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Additional_Filters">Additional Filters</p>
            <label cvLocalizedText langSection="CXOne_Modal" langKey="Data_Attributes">Data Attributes</label>
            <cv-cxone-attribute-selector
                [pageName]="stateKey + '_temp'"
                [settingsManager]="settingsManager"
                [moduleManager]="moduleManager">
            </cv-cxone-attribute-selector>
        </div>
        <div>
            <cv-metric-dynamic-filters
                *ngIf="module.SettingMetricSelector"
                [selectedMetrics]="settingsManager.selectedMetricIDs"
                [moduleManager]="moduleManager"
                (filterablesLoaded)="onFilterablesLoaded($event)"
            ></cv-metric-dynamic-filters>
        </div>
        
        <ng-container #insideAtt></ng-container>
    </div>
    <ng-container #afterAtt></ng-container>
    <div class="metric-selector-button-container moduleContainer" #metricSelectorContainer></div>
    <ng-container #afterMetric></ng-container>
    <ng-container #afterAll></ng-container>
</div>
<div class="modal-body cxms-loader-holder p-0 position-relative " *ngIf="settingsLoading || !moduleManager || !settingsManager">
    <cv-loader size="medium" [overlay]="false"></cv-loader>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary modal-footer-btn ml-auto" (click)="cancel()" cvLocalizedText langSection="CXOne_Modal" langKey="Cancel">Cancel</button>
    <button class="btn btn-primary modal-footer-btn ml-2" (click)="save()" 
        [disabled]="!isValid || settingsLoading|| !isPatternValid || !isModuleNameEmpty() || 
        (moduleManager.container.moduleId === 131 && moduleManager.moduleSettings.reportingSetName === undefined)" cvLocalizedText langSection="CXOne_Modal" langKey="Save">Save</button>
</div>
